export function toDefault<K extends string>(key: K) {
    return function <T>(value: {[key in K]: T}) {
        return {default: value[key]};
    };
}
